import React, { useEffect, useRef } from "react";
import AirDatepicker from "air-datepicker";
import "air-datepicker/air-datepicker.css";
import localeId from "air-datepicker/locale/id";

interface TanggalPickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  dateFormat?: string;
  timeFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  className?: string;
  timepicker?: boolean;
}

const TanggalPicker = ({
  value,
  onChange,
  placeholder = "Pilih tanggal...",
  dateFormat = "dd MMMM yyyy",
  timeFormat,
  minDate,
  maxDate,
  disabled = false,
  className = "",
  timepicker = false,
}: TanggalPickerProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const datepickerRef = useRef<AirDatepicker | null>(null);

  useEffect(() => {
    if (inputRef.current && !datepickerRef.current) {
      datepickerRef.current = new AirDatepicker(inputRef.current, {
        locale: localeId,
        dateFormat: dateFormat,
        timeFormat: timeFormat,
        autoClose: true,
        timepicker: timepicker,
        minDate: minDate,
        maxDate: maxDate,
        selectedDates: value ? [value] : [],
        onSelect: ({ date }) => {
          if (Array.isArray(date)) {
            onChange(date[0] || null);
          } else {
            onChange(date || null);
          }
        },
        buttons: timepicker ? ["today", "clear"] : ["today", "clear"],
        navTitles: {
          days: "MMMM yyyy",
          months: "yyyy",
          years: "yyyy1 - yyyy2",
        },
      });
    }

    return () => {
      if (datepickerRef.current) {
        datepickerRef.current.destroy();
        datepickerRef.current = null;
      }
    };
  }, []);

  // Update datepicker when value changes externally
  useEffect(() => {
    if (datepickerRef.current) {
      if (value) {
        datepickerRef.current.selectDate(value, { silent: true });
      } else {
        datepickerRef.current.clear({ silent: true });
      }
    }
  }, [value]);

  // Update min/max dates
  useEffect(() => {
    if (datepickerRef.current) {
      datepickerRef.current.update({
        minDate: minDate,
        maxDate: maxDate,
      });
    }
  }, [minDate, maxDate]);

  return (
    <>
      <style>{`
        .air-datepicker {
          z-index: 9999 !important;
        }
      `}</style>
      <input
        ref={inputRef}
        type="text"
        className={`form-control ${className}`}
        placeholder={placeholder}
        disabled={disabled}
        readOnly
        autoComplete="off"
      />
    </>
  );
};

export default TanggalPicker;

